module.exports = __webpack_public_path__ + "static/media/schlumberger.cf824634.svg";